import { createContext, Dispatch, MouseEventHandler, SetStateAction } from 'react';
import { LinkProps } from 'react-router-dom';

import { SearchResultItem } from '@models/SearchResults';
import { DetailedTitle, SimpleTitle, TTitleContext } from '@models/Title';

export type DetailedTitleMap = {
  [masterId: string]: {
    [indexName: string]: {
      episodes?: DetailedTitle[];
      title: DetailedTitle;
    };
  };
};

type TitleLinkProps = Pick<LinkProps, 'preventScrollReset' | 'replace' | 'to'> & {
  onClick: MouseEventHandler<HTMLElement>;
};

export type GetTitleLinkPropsFn = (
  titleContext: TTitleContext,
  viewTitleAsSubscriber?: boolean
) => TitleLinkProps;

export type MetadataContextValues = {
  addHighlights: (masterId: string, highlights: Record<string, string[]>) => void;
  addSimpleTitles: (titles: SimpleTitle[]) => void;
  closeDetailPanel: () => void;
  getTitleLinkProps: GetTitleLinkPropsFn;
  highlights: Record<string, Record<string, string[]>>;
  selectedHighlights?: Record<string, string[]>;
  selectTitle: (titleContext: TTitleContext, viewTitleAsSubscriber?: boolean) => void;
  setSearchResults: (titles: SearchResultItem<SimpleTitle>[]) => void;
  setViewTitleAsSubscriber: Dispatch<SetStateAction<boolean>>;
  titlePath: TTitleContext[];
  viewTitleAsSubscriber: boolean;
};

const MetadataContext = createContext<MetadataContextValues>({
  addHighlights: () => void 0,
  addSimpleTitles: () => void 0,
  closeDetailPanel: () => void 0,
  getTitleLinkProps: () => ({}) as TitleLinkProps,
  highlights: {},
  selectTitle: () => void 0,
  setSearchResults: () => void 0,
  setViewTitleAsSubscriber: () => void 0,
  titlePath: [],
  viewTitleAsSubscriber: false,
});

export default MetadataContext;
